import axios, { AxiosError } from "axios";
import axiosRetry from "axios-retry";
import { refreshPage } from "src/store/errorBoundarySlice";
import store from "../store/store";
import authService from "src/services/authService";

const apiClient = axios.create({
  baseURL: "https://gamma.mena.safer-api.whs.amazon.dev",
});

axiosRetry(apiClient, {
  retries: 1, // number of retries
  retryDelay: (retryCount) => {
    console.log(`retry attempt: ${retryCount}`);
    // use store.dispatch(getUser()) will make retry instantly, which cause more chance to having race condition
    authService.login();
    return retryCount * 2000; // time interval between retries
  },
  retryCondition: (error: AxiosError) => {
    // if retry condition is not specified, by default idempotent requests are retried
    console.log(JSON.stringify(error));
    const status = error.response?.status;
    if (!status || status != 401) {
      return false;
    }
    return true;
  },
});

apiClient.interceptors.response.use(
  (response) => response,
  (error: AxiosError) => {
    if (error.response?.status === 403) {
      store.dispatch(refreshPage());
    }
    return Promise.reject(error);
  },
);
export default apiClient;
